import { Ref } from '@vue/composition-api'
import { Validation } from '@vuelidate/core'
import { ValidationStates } from '@telia/shared-ui-components'

const showValidationError = ($v: Validation, fieldKey: string): boolean => {
  return $v[fieldKey].$invalid && $v[fieldKey].$dirty
}

export const getValidationMessage = ($v: Validation, fieldKey: string): Ref<string> | string => {
  return $v[fieldKey]?.$errors[0]?.$message || ''
}

export const getValidationState = ($v: Validation, fieldKey: string): string => {
  return showValidationError($v, fieldKey)
    ? ValidationStates.Invalid
    : ValidationStates.Valid
}
